var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "span",
    [
      _c(
        _setup.Button,
        {
          staticClass: "btn-sm border me-2",
          nativeOn: {
            click: function ($event) {
              return _setup.openSiteTreeModal.apply(null, arguments)
            },
          },
        },
        [_vm._v("\n        Browse…\n    ")]
      ),
      _vm._v(" "),
      _setup.pageId
        ? _c(_setup.PagePath, {
            staticClass: "small",
            attrs: { "page-id": _setup.pageId },
          })
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }